import { render, staticRenderFns } from "./IconOverview.vue?vue&type=template&id=939caa5a&scoped=true&"
import script from "./IconOverview.vue?vue&type=script&lang=js&"
export * from "./IconOverview.vue?vue&type=script&lang=js&"
import style0 from "./IconOverview.vue?vue&type=style&index=0&id=939caa5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939caa5a",
  null
  
)

export default component.exports